exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.image-box[data-v-7aaaea78] {\n  margin-top: 6.875rem;\n  text-align: center;\n}\n.image-box img[data-v-7aaaea78] {\n    width: 11.125rem;\n}\n.success-message[data-v-7aaaea78] {\n  margin: 1.875rem;\n}\n", "", {"version":3,"sources":["/srv/release/src/pages/bind/SuccessPage.vue"],"names":[],"mappings":";AA8CA;EACE,qBAA4B;EAC5B,mBAAkB;CAKnB;AAPD;IAKI,iBAAuB;CACxB;AAGH;EACE,iBAAuB;CACxB","file":"SuccessPage.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import '../../assets/scss/vars/base';\n\n.image-box {\n  margin-top: $base-size * 110;\n  text-align: center;\n\n  img {\n    width: $base-size * 178;\n  }\n}\n\n.success-message {\n  margin: $base-size * 30;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7aaaea78","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/bind/SuccessPage.vue
// module id = 4eQs
// module chunks = 1